/**
 * v-click-outside directive
 * 用於檢測元素外部的點擊事件
 *
 * 使用方式：
 * <div v-click-outside="handleClickOutside">
 *   內容
 * </div>
 *
 * 或傳入選項：
 * <div v-click-outside="{ handler: handleClickOutside, exclude: ['#modal', '.popup'] }">
 *   內容
 * </div>
 */

const clickOutsideClient = {
  // SSR support: return empty props as this directive only works on client
  getSSRProps() {
    return {}
  },

  mounted(el, binding) {
    const { handler, exclude = [] } = typeof binding.value === 'function' ? { handler: binding.value } : binding.value

    el._clickOutsideHandler = (event) => {
      // 檢查點擊是否在元素內部
      if (el.contains(event.target)) {
        return
      }

      // 檢查點擊是否在排除的元素中
      const isExcluded = exclude.some((selector) => {
        const excludedEl = document.querySelector(selector)
        return excludedEl && excludedEl.contains(event.target)
      })

      if (isExcluded) {
        return
      }

      // 執行回調
      if (handler && typeof handler === 'function') {
        handler(event)
      }
    }

    // 延遲綁定，避免立即觸發
    // 追蹤 timeout ID，確保在 unmount 時可以清除
    el._clickOutsideTimeoutId = setTimeout(() => {
      document.addEventListener('click', el._clickOutsideHandler)
      el._clickOutsideTimeoutId = null
    }, 0)
  },

  unmounted(el) {
    // 清除待執行的 timeout
    if (el._clickOutsideTimeoutId) {
      clearTimeout(el._clickOutsideTimeoutId)
      el._clickOutsideTimeoutId = null
    }
    if (el._clickOutsideHandler) {
      document.removeEventListener('click', el._clickOutsideHandler)
      delete el._clickOutsideHandler
    }
  },
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('click-outside', clickOutsideClient)
})
